import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { CATALOG_EMPTY_STATE_TRANSLATION_KEY } from "../constants";
var en = /*#__PURE__*/_defineProperty({}, CATALOG_EMPTY_STATE_TRANSLATION_KEY, {
  CATALOG_EMPTY_STATE_CHIP_ALL: 'All',
  CATALOG_EMPTY_STATE_TITLE: 'What do you want to see?',
  CATALOG_EMPTY_STATE_GO_TO_CATALOG: 'Go to catalog',
  CATALOG_EMPTY_STATE_STUDY_PLAN_TITLE: 'You haven’t created your study plan yet',
  CATALOG_EMPTY_STATE_STUDY_PLAN_DESCRIPTION: 'Organize your week to achieve your learning goals.',
  CATALOG_EMPTY_STATE_STUDY_PLAN_BUTTON: 'Create study plan',
  CATALOG_EMPTY_STATE_COURSES_TITLE: "{{name}}'s Courses",
  CATALOG_EMPTY_STATE_SHOW_MORE: 'See filtered courses',
  CATALOG_EMPTY_STATE_COURSE_CARD_CTA: 'View details'
});
export default en;